// src/services/api.ts
import axios from "axios";

// Backend is mounted under /api/ -> proxy_pass http://127.0.0.1:1000
// Django URLs are prefixed with /SuiviCongelcam/, so token endpoints are:
//   /api/SuiviCongelcam/token/
const API_URL = import.meta.env.VITE_API_URL || "https://synchroerp.cloud";

export const api = axios.create({
  baseURL: API_URL,
});

// Récupère une liste depuis l'API et garantit un tableau (évite "x.map is not a function"
// si le backend renvoie un objet/erreur au lieu d'un tableau).
export async function getList<T>(url: string): Promise<T[]> {
  const res = await api.get(url);
  return Array.isArray(res.data) ? (res.data as T[]) : [];
}


// Intercepteur pour ajouter automatiquement le token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
